// Responsive tabs/accordion. Basically just adds class .tabs-active to first tab on load and then any tab clicked on. you show and hide the proceeding content through the css
// Responsive behavior is in the CSS
$(document).ready(function () {

    //loop through all instances of tabs on the page and add ".tabs-active" to the first one
    initTabs();

    //create the mobile accordion triggers and insert them into the dom if the accordion modifier class is present
    $('.tabs--accordion .tabs-trigger').each(function () {
        var theTrigger = $(this).attr('data-trigger');
        var theText = $(this).text()
        var theTarget = $(".tabs-contentItem[data-target^='" + theTrigger + "']");
        var theToggle = $("<div>", { "class": "tabs-accordionTrigger", 'data-trigger': theTrigger, }).html(theText);
        $(this).closest('.tabs').find(theTarget).before(theToggle);
        $('.tabs-accordionTrigger:first-of-type').addClass('tabs-selected');
    });
    //hook up the show/hide functionality of the triggers
    $('.tabs-trigger, .tabs-accordionTrigger').click(function () {
        var activeTab = $(this).attr('data-trigger');
        if (!$(this).hasClass('tabs-selected')) {
            $(this).closest('.tabs').find('.tabs-selected').removeClass('tabs-selected');
            $(this).closest('.tabs').find($("[data-trigger^='" + activeTab + "']")).addClass('tabs-selected');
            $(this).closest('.tabs').find($('.tabs-contentItem')).removeClass('tabs-open');
            $(this).closest('.tabs').find($(".tabs-contentItem[data-target^='" + activeTab + "']")).addClass('tabs-open tabs-opening');
            setTimeout(function () {
                $('.tabs-contentItem').removeClass('tabs-opening');
            }, 800);
        }

        if ($(this).hasClass('tabs-trigger')) {
            window.location.hash = activeTab;
        }
    });
    //scroll opened accordion item to top of page
    $('.tabs-accordionTrigger').on('click', function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top - 50
        }, 500);
    });

    var hash = getUrlHash();
    if (isHashInTabs(hash)) {
        openTabByHash(hash);
    }

    $('.pageCols a[href^="#"]').click(function (e) {
        var hash = $(this).attr('href');
        if(hash == '#') return;
        if (isHashInTabs(hash)) {
            openTabByHash(hash);
        }
        return true;
    });

});

function getUrlHash() {
    let url = new URL(window.location.href);
    let hash = url.hash;
    if (!hash) return false;
    return hash;
}

function isHashInTabs(hash) {
    if(!hash) return false;
    let hashName = hash.replace('#', '');
    let hashTab = $('.tabs-trigger[data-trigger="' + hashName + '"]');
    if (hashTab.length > 0) return true;
    return false;
}

function openTabByHash(hash) {
    let hashName = hash.replace('#', '');
    let hashTab = $('.tabs-trigger[data-trigger="' + hashName + '"]');
    if (hashTab.length > 0) {
        hashTab.trigger('click');
    }
}

function initTabs() {
    if ($('.tabs').length > 0) {
        $('.tabs-triggerList').removeClass('tabs-selected');
        $('.tabs-trigger:first-child').addClass('tabs-selected');
        $('.tabs-contentItem:first-of-type').addClass('tabs-open');
    }
}